var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.open
    ? _c(
        "div",
        {
          directives: [
            {
              name: "dismiss",
              rawName: "v-dismiss",
              value: _vm.computedDismiss,
              expression: "computedDismiss",
            },
          ],
          staticClass: "jade-floating",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "scroll-lock",
                  rawName: "v-scroll-lock",
                  value: _vm.open,
                  expression: "open",
                },
              ],
              ref: "floating",
              class: _vm.computedClassOverlay,
              staticStyle: {
                position: "fixed",
                overflow: "auto",
                inset: "0px",
                "transition-property": "opacity",
                "transition-duration": "250ms",
              },
              style: { zIndex: _vm.zIndex },
            },
            [
              _c(
                "FocusTrap",
                {
                  ref: "focusTrap",
                  attrs: {
                    active: _vm.open,
                    allowOutsideClick: _vm.allowOutsideClick,
                    returnFocusOnDeactivate: "",
                  },
                },
                [_c("div", [_vm._t("default")], 2)]
              ),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }